import { useCurrency } from '../contexts/CurrencyContext';
import { DollarSign } from 'lucide-react';

function CurrencySelector({ className = '' }) {
  const { currency, setCurrency } = useCurrency();

  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid="currency-selector">
      <DollarSign className="w-4 h-4 text-gray-400" />
      <button
        onClick={() => setCurrency('EUR')}
        data-testid="currency-eur-btn"
        className={`px-2 py-1 rounded text-sm font-medium transition ${
          currency === 'EUR'
            ? 'bg-orange-500 text-white'
            : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
        }`}
      >
        EUR
      </button>
      <button
        onClick={() => setCurrency('USD')}
        data-testid="currency-usd-btn"
        className={`px-2 py-1 rounded text-sm font-medium transition ${
          currency === 'USD'
            ? 'bg-orange-500 text-white'
            : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
        }`}
      >
        USD
      </button>
    </div>
  );
}

export default CurrencySelector;
